import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from './ui/dialog';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Button } from './ui/button';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from './ui/select';
import { useApp } from '../context/AppContext';
import { statusOptions, releaseStatusOptions } from '../mock';
import { toast } from '../hooks/use-toast';

export default function NewGuestDialog({ open, onOpenChange }) {
  const { addGuest, activeShow } = useApp();
  const [form, setForm] = useState({
    name: '', email: '', phone: '', company: '', role: '', location: '', episodeTitle: '', episodeDate: '',
    recordingDate: '', status: 'invited', releaseStatus: 'pending', cc1: '', cc2: ''
  });

  const set = (k, v) => setForm(p => ({ ...p, [k]: v }));

  const submit = () => {
    if (!form.name || !form.email) {
      toast({ title: 'Name and email required' });
      return;
    }
    const ccList = [form.cc1, form.cc2].map(x => (x || '').trim()).filter(Boolean);
    addGuest({
      name: form.name,
      email: form.email,
      phone: form.phone,
      company: form.company,
      role: form.role,
      location: form.location,
      episodeTitle: form.episodeTitle,
      episodeDate: form.episodeDate,
      status: form.status,
      releaseStatus: form.releaseStatus,
      platforms: { apple: '', spotify: '', youtube: '', libsyn: '' },
      socials: { linkedin: '', instagram: '', twitter: '' },
      interestedParties: ccList,
      tags: [],
      thumbnail: '',
      thumbnail16x9: '',
      notes: '',
      avatar: '',
      recordingDate: form.recordingDate,
      signedDate: null
    });
    toast({ title: 'Guest added' });
    setForm({ name: '', email: '', phone: '', company: '', role: '', location: '', episodeTitle: '', episodeDate: '', recordingDate: '', status: 'invited', releaseStatus: 'pending', cc1: '', cc2: '' });
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader><DialogTitle>Add guest / prospect to {activeShow.name}</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div className="col-span-2"><Label>Name</Label><Input value={form.name} onChange={(e) => set('name', e.target.value)} /></div>
          <div className="col-span-2"><Label>Email</Label><Input value={form.email} onChange={(e) => set('email', e.target.value)} /></div>
          <div><Label>Additional email 1 (cc)</Label><Input value={form.cc1} onChange={(e) => set('cc1', e.target.value)} placeholder="e.g. agent@..." /></div>
          <div><Label>Additional email 2 (cc)</Label><Input value={form.cc2} onChange={(e) => set('cc2', e.target.value)} placeholder="e.g. producer@..." /></div>
          <div className="col-span-2"><Label>Cell phone</Label><Input type="tel" data-testid="new-guest-phone" value={form.phone} onChange={(e) => set('phone', e.target.value)} placeholder="+1 555 123 4567" /></div>
          <div><Label>Company</Label><Input value={form.company} onChange={(e) => set('company', e.target.value)} /></div>
          <div><Label>Role</Label><Input value={form.role} onChange={(e) => set('role', e.target.value)} /></div>
          <div className="col-span-2"><Label>Location</Label><Input value={form.location} onChange={(e) => set('location', e.target.value)} placeholder="e.g. Tbilisi, Georgia · Napa, CA · London, UK" /></div>
          <div className="col-span-2"><Label>Episode title</Label><Input value={form.episodeTitle} onChange={(e) => set('episodeTitle', e.target.value)} /></div>
          <div><Label>Air date</Label><Input type="date" value={form.episodeDate} onChange={(e) => set('episodeDate', e.target.value)} /></div>
          <div><Label>Recording date &amp; time</Label><Input type="datetime-local" value={form.recordingDate} onChange={(e) => set('recordingDate', e.target.value)} /></div>
          <div>
            <Label>Status</Label>
            <Select value={form.status} onValueChange={(v) => set('status', v)}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>{statusOptions.map(s => <SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div className="col-span-2">
            <Label>Release status</Label>
            <Select value={form.releaseStatus} onValueChange={(v) => set('releaseStatus', v)}>
              <SelectTrigger><SelectValue /></SelectTrigger>
              <SelectContent>{releaseStatusOptions.map(s => <SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>)}</SelectContent>
            </Select>
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={submit} className="text-white" style={{ background: activeShow.color }}>Add guest</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
